'use client';

import { ReactNode } from 'react';
import { AuthSplitLayout } from '@test-prep/ui';
import { AuthHero, AuthHeroMobileBar } from './AuthHero';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <AuthSplitLayout panel={<AuthHero />} mobileBar={<AuthHeroMobileBar showBackLink />} title={title} subtitle={subtitle}>
      {children}
    </AuthSplitLayout>
  );
}
